/* ==========================================================================
   RACINEA — comportamientos propios
   Todo vanilla, sin librerias. Cada init comprueba si su elemento existe,
   asi el mismo archivo sirve para todas las paginas.
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1. Animaciones de entrada (un solo observador compartido)
     --------------------------------------------------------------------- */
  var observadorReveal = null;

  function initReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll('.mt-reveal, .mt-reveal-zoom, .mt-ligne-masque');
    if (!elementos.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    if (!observadorReveal) {
      observadorReveal = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('mt-visible');
          observadorReveal.unobserve(entrada.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }

    elementos.forEach(function (el) {
      if (!el.classList.contains('mt-visible')) observadorReveal.observe(el);
    });

    /* Red de seguridad: si por lo que sea el observador no llega a disparar
       (pestana en segundo plano, navegador raro, JS a medias), el contenido
       NO puede quedarse invisible. A los 4 s se muestra todo si nada se ha
       revelado todavia. */
    window.setTimeout(function () {
      if (document.querySelector('.mt-visible')) return;
      document.querySelectorAll('.mt-reveal, .mt-reveal-zoom, .mt-ligne-masque')
        .forEach(function (el) { el.classList.add('mt-visible'); });
    }, 4000);
  }

  /* Contenedor que hace scroll de verdad: algunos temas (Horizon) no
     scrollean la ventana sino un envoltorio interno. */
  function contenedorScroll() {
    /* En movil .page-wrapper tiene overflow:visible y su scrollHeight es igual que su
       clientHeight: no scrollea, el que scrollea es el documento. Devolverlo igualmente
       hacia que los saltos de ancla no hicieran nada en el telefono. */
    var caja = document.querySelector('.page-wrapper');
    if (caja && caja.scrollHeight > caja.clientHeight + 4) return caja;
    return window;
  }

  /* ---------------------------------------------------------------------
     2. Cifras que cuentan al entrar en pantalla
     --------------------------------------------------------------------- */
  function initCompteurs(raiz) {
    var cifras = (raiz || document).querySelectorAll('[data-mt-compteur]');
    if (!cifras.length) return;

    function pintar(el, valor) {
      var decimales = parseInt(el.getAttribute('data-mt-decimales') || '0', 10);
      var prefijo = el.getAttribute('data-mt-prefijo') || '';
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      var texto = valor.toFixed(decimales).replace('.', ',');
      el.textContent = prefijo + texto + sufijo;
    }

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-mt-compteur'));
      if (isNaN(destino)) return;
      if (reducedMotion) { pintar(el, destino); return; }

      var duracion = parseInt(el.getAttribute('data-mt-duracion') || '1500', 10);
      var inicio = null;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var avance = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - avance, 3);
        pintar(el, destino * suave);
        if (avance < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { animar(el); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        animar(entrada.target);
        obs.unobserve(entrada.target);
      });
    }, { threshold: 0.4 });

    cifras.forEach(function (el) { obs.observe(el); });
  }

  /* ---------------------------------------------------------------------
     3. Acordeones (FAQ y fichas)
     --------------------------------------------------------------------- */
  function initAcordeones(raiz) {
    var grupos = (raiz || document).querySelectorAll('[data-mt-acc]');
    if (!grupos.length) return;

    grupos.forEach(function (grupo) {
      if (grupo.dataset.mtAccListo === '1') return;
      grupo.dataset.mtAccListo = '1';

      var unoSolo = grupo.getAttribute('data-mt-acc') === 'solo';

      grupo.querySelectorAll('.mt-acc__tete').forEach(function (tete) {
        tete.addEventListener('click', function () {
          var item = tete.closest('.mt-acc__item');
          if (!item) return;
          var abierto = item.classList.contains('est-ouvert');

          if (unoSolo) {
            grupo.querySelectorAll('.mt-acc__item.est-ouvert').forEach(function (otro) {
              if (otro !== item) {
                otro.classList.remove('est-ouvert');
                var t = otro.querySelector('.mt-acc__tete');
                if (t) t.setAttribute('aria-expanded', 'false');
              }
            });
          }

          item.classList.toggle('est-ouvert', !abierto);
          tete.setAttribute('aria-expanded', String(!abierto));
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     4. Comparador antes / despues
     --------------------------------------------------------------------- */
  function initComparadores(raiz) {
    var comps = (raiz || document).querySelectorAll('[data-mt-comp]');
    if (!comps.length) return;

    comps.forEach(function (comp) {
      if (comp.dataset.mtCompListo === '1') return;
      comp.dataset.mtCompListo = '1';

      var arrastrando = false;

      function mover(clienteX) {
        var caja = comp.getBoundingClientRect();
        if (!caja.width) return;
        var pos = ((clienteX - caja.left) / caja.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        comp.style.setProperty('--mt-pos', pos + '%');
      }

      function inicio(e) {
        arrastrando = true;
        comp.classList.add('est-actif');
        mover(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function durante(e) {
        if (!arrastrando) return;
        mover(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function fin() {
        arrastrando = false;
        comp.classList.remove('est-actif');
      }

      comp.addEventListener('mousedown', inicio);
      window.addEventListener('mousemove', durante);
      window.addEventListener('mouseup', fin);
      comp.addEventListener('touchstart', inicio, { passive: true });
      comp.addEventListener('touchmove', durante, { passive: true });
      comp.addEventListener('touchend', fin);
      comp.addEventListener('click', function (e) { if (!arrastrando) mover(e.clientX); });

      /* Teclado: accesible con flechas */
      var boton = comp.querySelector('.mt-comp__bouton');
      if (boton) {
        boton.setAttribute('tabindex', '0');
        boton.setAttribute('role', 'slider');
        boton.addEventListener('keydown', function (e) {
          var actual = parseFloat((comp.style.getPropertyValue('--mt-pos') || '50%').replace('%', ''));
          if (e.key === 'ArrowLeft') { comp.style.setProperty('--mt-pos', Math.max(0, actual - 4) + '%'); e.preventDefault(); }
          if (e.key === 'ArrowRight') { comp.style.setProperty('--mt-pos', Math.min(100, actual + 4) + '%'); e.preventDefault(); }
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     5. Parallax suave del hero (solo transform, va por GPU)
     --------------------------------------------------------------------- */
  function initParallax(raiz) {
    var capas = (raiz || document).querySelectorAll('[data-mt-parallax]');
    if (!capas.length || reducedMotion) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var enCurso = false;

    function pintar() {
      capas.forEach(function (capa) {
        var intensidad = parseFloat(capa.getAttribute('data-mt-parallax')) || 0.12;
        var caja = capa.getBoundingClientRect();
        var centro = caja.top + caja.height / 2 - window.innerHeight / 2;
        capa.style.transform = 'translate3d(0,' + (centro * intensidad * -1).toFixed(2) + 'px,0)';
      });
      enCurso = false;
    }

    function alScroll() {
      if (enCurso) return;
      enCurso = true;
      requestAnimationFrame(pintar);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    var caja = contenedorScroll();
    if (caja !== window) caja.addEventListener('scroll', alScroll, { passive: true });

    pintar();
  }

  /* ---------------------------------------------------------------------
     6. Barra fija de compra en movil
     --------------------------------------------------------------------- */
  function initBarraCompra() {
    var barra = document.querySelector('[data-mt-barre]');
    if (!barra) return;

    var referencia = document.querySelector('[data-mt-barre-ref]');
    if (!referencia || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        barra.classList.toggle('est-visible', !entrada.isIntersecting && entrada.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });

    obs.observe(referencia);

    var botonBarra = barra.querySelector('[data-mt-barre-btn]');
    if (botonBarra) {
      botonBarra.addEventListener('click', function (e) {
        var real = document.querySelector('[data-mt-btn-achat]');
        if (real) { e.preventDefault(); real.click(); }
      });
    }
  }

  /* ---------------------------------------------------------------------
     7. Galeria de producto
     --------------------------------------------------------------------- */
  function initGaleria() {
    var galeria = document.querySelector('[data-mt-galerie]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-mt-galerie-principale]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var grande = mini.getAttribute('data-mt-miniatura');
        if (!grande) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.setAttribute('src', grande);
          principal.removeAttribute('srcset');
          principal.style.opacity = '1';
        }, 160);
        miniaturas.forEach(function (m) { m.classList.remove('est-actif'); });
        mini.classList.add('est-actif');
      });
    });
  }

  /* ---------------------------------------------------------------------
     8. Selector de variantes (solo si el producto tiene varias)
     --------------------------------------------------------------------- */
  function initVariantes() {
    var datos = document.querySelector('[data-mt-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var campoId = document.querySelector('[data-mt-variante-id]');
    var elPrecio = document.querySelector('[data-mt-prix]');
    var elPrecioAntes = document.querySelector('[data-mt-prix-ancien]');
    var elEconomie = document.querySelector('[data-mt-economie]');
    var boton = document.querySelector('[data-mt-btn-achat]');
    var botonTexto = document.querySelector('[data-mt-btn-texte]');
    var barraPrecio = document.querySelector('.mt-barre__prix');
    var barraBoton = document.querySelector('[data-mt-barre-btn]');
    var radios = document.querySelectorAll('[data-mt-option]');
    var ofertas = document.querySelectorAll('[data-mt-offre]');

    var textoDisponible = botonTexto ? botonTexto.textContent.trim() : '';
    var textoEpuise = boton ? (boton.getAttribute('data-mt-texte-epuise') || 'Épuisé') : 'Épuisé';

    /* Pinta en pantalla la variante elegida (precio, boton, barra movil) */
    function aplicar(encontrada) {
      if (!encontrada) return;

      if (campoId) campoId.value = encontrada.id;

      if (elPrecio) elPrecio.textContent = encontrada.prixFormate;
      if (barraPrecio) barraPrecio.textContent = encontrada.prixFormate;

      var hayRebaja = encontrada.prixAncien && encontrada.prixAncien > encontrada.prix;
      if (elPrecioAntes) {
        elPrecioAntes.textContent = hayRebaja ? encontrada.prixAncienFormate : '';
        elPrecioAntes.style.display = hayRebaja ? '' : 'none';
      }
      if (elEconomie) {
        elEconomie.textContent = hayRebaja ? '−' + (encontrada.remise || 0) + ' %' : '';
        elEconomie.style.display = hayRebaja ? '' : 'none';
      }

      [boton, barraBoton].forEach(function (b) {
        if (b) b.disabled = !encontrada.disponible;
      });
      if (botonTexto) botonTexto.textContent = encontrada.disponible ? textoDisponible : textoEpuise;
    }

    /* --- Caso A: tarjetas de oferta (un solo desplegable) --- */
    if (ofertas.length) {
      var marcarTarjetas = function () {
        ofertas.forEach(function (radio) {
          var tarjeta = radio.closest('.mt-offre');
          if (tarjeta) tarjeta.classList.toggle('est-actif', radio.checked);
        });
      };

      ofertas.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var elegida = variantes.find(function (variante) {
            return String(variante.id) === String(radio.value);
          });
          aplicar(elegida);
          marcarTarjetas();
        });
      });

      var marcado = document.querySelector('[data-mt-offre]:checked');
      if (marcado) {
        aplicar(variantes.find(function (variante) { return String(variante.id) === String(marcado.value); }));
      }
      marcarTarjetas();
      return;
    }

    /* --- Caso B: selector clasico por opciones --- */
    if (!campoId || !radios.length) return;

    function seleccionadas() {
      var valores = [];
      radios.forEach(function (radio) {
        if (!radio.checked) return;
        valores[parseInt(radio.getAttribute('data-mt-option'), 10) - 1] = radio.value;
      });
      return valores;
    }

    function actualizar() {
      var elegidas = seleccionadas();

      var encontrada = variantes.find(function (variante) {
        return variante.options.every(function (opcion, i) { return opcion === elegidas[i]; });
      });
      if (!encontrada) return;

      aplicar(encontrada);

      radios.forEach(function (radio) {
        var etiqueta = radio.closest('.mt-pdp__valeur');
        if (etiqueta) etiqueta.classList.toggle('est-actif', radio.checked);
      });
    }

    radios.forEach(function (radio) { radio.addEventListener('change', actualizar); });
    actualizar();
  }

  /* ---------------------------------------------------------------------
     10. Carrusel de opiniones
         Se apoya en scroll-snap nativo: el deslizamiento con el dedo ya
         funciona solo. El JS solo añade flechas, puntos y avance automático.
     --------------------------------------------------------------------- */
  function initCarruseles(raiz) {
    var carruseles = (raiz || document).querySelectorAll('[data-mt-carrusel]');
    if (!carruseles.length) return;

    carruseles.forEach(function (carrusel) {
      if (carrusel.dataset.mtCarruselListo === '1') return;
      carrusel.dataset.mtCarruselListo = '1';

      var piste = carrusel.querySelector('[data-mt-carrusel-piste]');
      var prev = carrusel.querySelector('[data-mt-carrusel-prev]');
      var next = carrusel.querySelector('[data-mt-carrusel-next]');
      var zonaPuntos = carrusel.querySelector('[data-mt-carrusel-puntos]');
      if (!piste) return;

      var tarjetas = [].slice.call(piste.children);
      if (tarjetas.length < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      function paso() {
        var a = tarjetas[0].getBoundingClientRect().width;
        var b = tarjetas[1] ? tarjetas[1].getBoundingClientRect().left - tarjetas[0].getBoundingClientRect().left : a;
        return b || a;
      }

      /* --- puntos --- */
      var puntos = [];
      if (zonaPuntos) {
        tarjetas.forEach(function (_, i) {
          var p = document.createElement('button');
          p.type = 'button';
          p.className = 'mt-avis__punto';
          p.setAttribute('aria-label', 'Avis ' + (i + 1));
          p.addEventListener('click', function () {
            detenerAuto();
            piste.scrollTo({ left: i * paso(), behavior: reducedMotion ? 'auto' : 'smooth' });
          });
          zonaPuntos.appendChild(p);
          puntos.push(p);
        });
      }

      function indiceActual() {
        return Math.round(piste.scrollLeft / paso());
      }

      function refrescar() {
        var i = indiceActual();
        puntos.forEach(function (p, n) { p.classList.toggle('est-actif', n === i); });
        var alPrincipio = piste.scrollLeft <= 2;
        var alFinal = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 2;
        if (prev) prev.disabled = alPrincipio;
        if (next) next.disabled = alFinal;
      }

      function mover(direccion) {
        piste.scrollBy({ left: direccion * paso(), behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { detenerAuto(); mover(-1); });
      if (next) next.addEventListener('click', function () { detenerAuto(); mover(1); });

      var esperando = false;
      piste.addEventListener('scroll', function () {
        if (esperando) return;
        esperando = true;
        requestAnimationFrame(function () { refrescar(); esperando = false; });
      }, { passive: true });

      /* --- teclado --- */
      piste.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { detenerAuto(); mover(-1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { detenerAuto(); mover(1); e.preventDefault(); }
      });

      /* --- avance automatico --- */
      var temporizador = null;
      function detenerAuto() {
        if (temporizador) { window.clearInterval(temporizador); temporizador = null; }
      }
      function arrancarAuto() {
        if (carrusel.getAttribute('data-mt-auto') !== 'true') return;
        if (reducedMotion) return;
        var intervalo = parseInt(carrusel.getAttribute('data-mt-intervalo'), 10) || 6000;
        detenerAuto();
        temporizador = window.setInterval(function () {
          if (document.hidden) return;
          var alFinal = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 2;
          if (alFinal) piste.scrollTo({ left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
          else mover(1);
        }, intervalo);
      }

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        carrusel.addEventListener(ev, detenerAuto, { passive: true });
      });

      refrescar();
      arrancarAuto();
    });
  }

  /* ---------------------------------------------------------------------
     9. Enlaces internos (#ancla) — este tema hace scroll dentro de un
        contenedor, asi que el salto nativo no siempre funciona.
     --------------------------------------------------------------------- */
  function initAnclas() {
    if (document.body.dataset.mtAnclasListo === '1') return;
    document.body.dataset.mtAnclasListo = '1';

    document.addEventListener('click', function (e) {
      var enlace = e.target.closest('a[href^="#"]');
      if (!enlace) return;

      var id = enlace.getAttribute('href').slice(1);
      if (!id) return;

      var destino = document.getElementById(id);
      if (!destino) return;

      e.preventDefault();

      var caja = contenedorScroll();
      var margen = 20;
      var cabecera = document.querySelector('#header-component');
      if (cabecera) margen += cabecera.offsetHeight;

      if (caja === window) {
        window.scrollTo({
          top: destino.getBoundingClientRect().top + window.scrollY - margen,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      } else {
        caja.scrollTo({
          top: destino.getBoundingClientRect().top - caja.getBoundingClientRect().top + caja.scrollTop - margen,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Arranque
     --------------------------------------------------------------------- */
  function arrancarTodo(raiz) {
    initReveals(raiz);
    initCompteurs(raiz);
    initAcordeones(raiz);
    initComparadores(raiz);
    initParallax(raiz);
    initBarraCompra();
    initGaleria();
    initVariantes();
    initCarruseles(raiz);
    initAnclas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancarTodo(document); });
  } else {
    arrancarTodo(document);
  }

  /* En el editor de Shopify, al recargar una seccion hay que reinicializar */
  document.addEventListener('shopify:section:load', function (e) {
    arrancarTodo(e.target);
  });
})();

/* Añadido opcional: si la casilla está marcada, el formulario deja de ir por la vía
   normal y se mandan las dos líneas de golpe a /cart/add.js.
   Ojo: mt-scripts.js se incluye desde cada seccion (12 en la ficha), asi que esto se
   ejecuta varias veces. Sin la marca en el dataset se enganchaban varios listeners y
   el carrito recibia el pedido repetido. */
function initAddon() {
  var caja = document.querySelector('[data-mt-addon]');
  if (!caja || caja.dataset.mtAddonListo) return;

  var check = caja.querySelector('[data-mt-addon-check]');
  var form = caja.closest('form[action*="/cart/add"]');
  if (!check || !form) return;

  caja.dataset.mtAddonListo = '1';

  form.addEventListener('submit', function (e) {
    if (!check.checked) return;              // sin marcar, comportamiento de siempre
    e.preventDefault();

    var variante = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!variante) return;
    var campoCantidad = form.querySelector('[name="quantity"]');
    var cantidad = campoCantidad ? parseInt(campoCantidad.value, 10) || 1 : 1;

    var boton = form.querySelector('[data-mt-btn-achat]');
    if (boton) boton.disabled = true;

    /* Las rutas del carrito las da el tema ya con el prefijo del idioma
       (/es-es/...). Escribirlas a mano manda al cliente espanol al carrito
       frances: paso de verdad y se detecto probando la compra. */
    /* OJO: el tema declara sus rutas con 'const Theme = {...}', asi que NO
       estan en window.Theme (una const de nivel superior no cuelga de window).
       Hay que mirar la variable a pelo con typeof, o esto cae siempre al valor
       por defecto sin prefijo de idioma. */
    var hayTema = typeof Theme !== 'undefined' && Theme.routes;
    var rutaAnadir = (hayTema && Theme.routes.cart_add_url) || '/cart/add.js';
    var rutaCarrito = (hayTema && Theme.routes.cart_url) || '/cart';

    fetch(rutaAnadir, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(variante.value), quantity: cantidad },
          { id: Number(check.value), quantity: 1 }
        ]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = rutaCarrito; })
      .catch(function () {
        if (boton) boton.disabled = false;
        check.checked = false;               // que no vuelva a entrar por aqui
        form.submit();
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddon);
} else {
  initAddon();
}
document.addEventListener('shopify:section:load', initAddon);

/* La fecha de entrega la calcula Liquid, pero si Shopify sirve la pagina cacheada
   puede quedarse atrasada unos minutos. Aqui se recalcula en el navegador con la
   fecha real del visitante, usando los mismos nombres de mes traducidos. */
function initEntrega() {
  var p = document.querySelector('[data-mt-entrega]');
  if (!p || p.dataset.mtEntregaListo) return;
  p.dataset.mtEntregaListo = '1';

  var min = parseInt(p.dataset.min, 10);
  var max = parseInt(p.dataset.max, 10);
  if (!min || !max) return;

  var meses = (p.dataset.meses || '').split(',').map(function (m) { return m.trim(); });
  if (meses.length !== 12) return;

  var sufijo = p.dataset.sufijo || '';
  var prefijo = p.dataset.prefijo || '';

  function texto(dias) {
    var d = new Date();
    d.setDate(d.getDate() + dias);
    return d.getDate() + sufijo + ' ' + prefijo + meses[d.getMonth()];
  }

  var a = p.querySelector('[data-mt-fecha-min]');
  var b = p.querySelector('[data-mt-fecha-max]');
  if (a) a.textContent = texto(min);
  if (b) b.textContent = texto(max);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEntrega);
} else {
  initEntrega();
}
document.addEventListener('shopify:section:load', initEntrega);


/* ---------------------------------------------------------------------
   Visor de fotos de las opiniones.
   Delegado en document: funciona con el carrusel y con las secciones que
   Shopify recarga en el editor, sin necesidad de reinicializar nada.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var capa = null;
  var imagen = null;
  var abridor = null;

  function construir() {
    if (capa) return;
    capa = document.createElement('div');
    capa.className = 'mt-zoom';
    capa.setAttribute('role', 'dialog');
    capa.setAttribute('aria-modal', 'true');
    capa.hidden = true;

    imagen = document.createElement('img');
    imagen.alt = '';
    capa.appendChild(imagen);

    var cerrar = document.createElement('button');
    cerrar.type = 'button';
    cerrar.className = 'mt-zoom__cerrar';
    cerrar.setAttribute('aria-label', 'Fermer');
    cerrar.innerHTML = '&times;';
    capa.appendChild(cerrar);

    capa.addEventListener('click', ocultar);
    document.body.appendChild(capa);
  }

  function mostrar(src, alt, origen) {
    construir();
    abridor = origen || null;
    imagen.src = src;
    imagen.alt = alt || '';
    capa.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // Reflow sincrono en vez de requestAnimationFrame: rAF no dispara si la
    // pestana esta en segundo plano y la capa se quedaria en opacity 0
    // bloqueando el scroll sin mostrar nada.
    void capa.offsetWidth;
    capa.setAttribute('data-abierto', '');
    capa.querySelector('.mt-zoom__cerrar').focus();
  }

  function ocultar() {
    if (!capa || capa.hidden) return;
    capa.removeAttribute('data-abierto');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      capa.hidden = true;
      imagen.removeAttribute('src');
      if (abridor && document.contains(abridor)) abridor.focus();
      abridor = null;
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest ? e.target.closest('[data-mt-zoom]') : null;
    if (!boton) return;
    var src = boton.getAttribute('data-mt-zoom');
    if (!src) return;
    e.preventDefault();
    var img = boton.querySelector('img');
    mostrar(src, img ? img.alt : '', boton);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') ocultar();
  });
})();

/* v1788393272 */

/* Cuenta atras de la cinta del anadido.

   Se calcula SIEMPRE desde el reloj real del visitante en ciclos cerrados
   (Date.now() % ciclo), nunca restando de un numero guardado. Dos razones:

   1. No se reinicia al recargar ni al volver atras. Un reloj que salta otra vez
      a 3:00:00 cada vez que el cliente refresca se delata solo.
   2. Se autocorrige. Un contador que va descontando de uno en uno se desfasa
      cuando el navegador congela la pestana en segundo plano — ya nos paso con
      otra cosa en este mismo tema. Aqui cada segundo se vuelve a leer la hora,
      asi que da igual cuantos avisos se pierdan.

   Al llegar a cero arranca el ciclo siguiente, que es lo que se pidio. */
function initRelojAddon() {
  var cajas = document.querySelectorAll('[data-mt-reloj]');
  if (!cajas.length) return;

  Array.prototype.forEach.call(cajas, function (caja) {
    if (caja.dataset.mtRelojListo) return;               // mt-scripts.js se carga
    var hh = caja.querySelector('[data-mt-reloj-h]');    // desde 12 secciones
    var mm = caja.querySelector('[data-mt-reloj-m]');
    var ss = caja.querySelector('[data-mt-reloj-s]');
    var horas = parseFloat(caja.dataset.horas);
    if (!hh || !mm || !ss || !horas || horas <= 0) return;
    caja.dataset.mtRelojListo = '1';

    var ciclo = horas * 3600 * 1000;

    function dos(n) { return n < 10 ? '0' + n : String(n); }

    function pinta() {
      var restanMs = ciclo - (Date.now() % ciclo);
      var s = Math.floor(restanMs / 1000);
      hh.textContent = dos(Math.floor(s / 3600));
      mm.textContent = dos(Math.floor((s % 3600) / 60));
      ss.textContent = dos(s % 60);
    }

    pinta();
    setInterval(pinta, 1000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) pinta();                     // al volver, sin esperar 1 s
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelojAddon);
} else {
  initRelojAddon();
}
document.addEventListener('shopify:section:load', initRelojAddon);

/* ---------------------------------------------------------------
   Carrusel de opiniones cortas bajo el botón de compra.
   Sin dependencias: la pista es un scroll horizontal con snap y los
   puntos solo leen y escriben scrollLeft. Si la sección no tiene
   opiniones, no hay nada que enganchar y la función se va de vacío.
   --------------------------------------------------------------- */
function initOpiniones() {
  document.querySelectorAll('[data-mt-ops]').forEach(function (caja) {
    if (caja.dataset.mtOpsListo === '1') return;          // no engancharlo dos veces
    caja.dataset.mtOpsListo = '1';

    var pista = caja.querySelector('[data-mt-ops-pista]');
    if (!pista) return;
    var puntos = Array.prototype.slice.call(caja.querySelectorAll('[data-mt-ops-punto]'));
    var fichas = Array.prototype.slice.call(pista.children);
    if (fichas.length < 2) return;

    function indiceActual() {
      var i = Math.round(pista.scrollLeft / pista.clientWidth);
      return Math.max(0, Math.min(fichas.length - 1, i));
    }

    function pintarPuntos() {
      var i = indiceActual();
      puntos.forEach(function (p, j) { p.classList.toggle('est-activo', j === i); });
    }

    function irA(i) {
      var destino = Math.max(0, Math.min(fichas.length - 1, i));
      // Ni scrollTo({behavior:'smooth'}) ni el scroll-behavior del CSS
      // arrancan cuando la pista lleva scroll-snap: en algunos motores el
      // desplazamiento se queda a cero. Se anima a mano, que va en todos.
      var fin = destino * pista.clientWidth;
      var inicio = pista.scrollLeft;
      var salto = fin - inicio;
      // Si la pestaña está en segundo plano, requestAnimationFrame no corre:
      // ahí se salta sin animación para que el carrusel no se quede clavado.
      var quieto = document.hidden ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (quieto || Math.abs(salto) < 2) {
        pista.scrollLeft = fin;
        pintarPuntos();
        return;
      }
      var t0 = null;
      var DURACION = 320;
      function paso(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / DURACION);
        var suave = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        pista.scrollLeft = inicio + salto * suave;
        if (p < 1) { requestAnimationFrame(paso); } else { pintarPuntos(); }
      }
      requestAnimationFrame(paso);
    }

    caja.querySelectorAll('[data-mt-ops-ir]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var paso = Number(boton.dataset.mtOpsIr) || 1;
        var siguiente = indiceActual() + paso;
        if (siguiente < 0) siguiente = fichas.length - 1;      // da la vuelta
        if (siguiente > fichas.length - 1) siguiente = 0;
        irA(siguiente);
      });
    });

    puntos.forEach(function (p) {
      p.addEventListener('click', function () { irA(Number(p.dataset.mtOpsPunto) || 0); });
    });

    var espera = null;
    pista.addEventListener('scroll', function () {
      if (espera) return;
      espera = setTimeout(function () { espera = null; pintarPuntos(); }, 90);
    }, { passive: true });

    pintarPuntos();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOpiniones);
} else {
  initOpiniones();
}
document.addEventListener('shopify:section:load', initOpiniones);
